import { HtmlString } from '@breezy/shared'
import classNames from 'classnames'
import DOMPurify from 'dompurify'
import { memo } from 'react'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import './HtmlRenderer.less'

type HtmlRendererProps = {
  className?: string
  htmlContent: HtmlString
}

export const HtmlRenderer = memo<HtmlRendererProps>(({ className, htmlContent }) => {
  const sanitizedHtml = DOMPurify.sanitize(htmlContent as string)

  return (
    <span className={classNames('bz-html-renderer', className)}>
      <ReactMarkdown rehypePlugins={[rehypeRaw]}>{sanitizedHtml}</ReactMarkdown>
    </span>
  )
})

HtmlRenderer.displayName = 'HtmlRenderer'
